import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.styl';

const InfoWrapper = ({ title, subtitle, children }) => (
  <div className={styles.wrapper}>
    <div className={styles.header}>
      <h3>{title}</h3>
      <div className={styles.subtitle}>{subtitle}</div>
    </div>
    <div className={styles.content}>{children}</div>
  </div>
);

InfoWrapper.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  subtitle: PropTypes.string,
};

export default InfoWrapper;



// WEBPACK FOOTER //
// ./src/components/common/Charts/InfoWrapper/index.jsx